<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="empty" *ngIf="faqs && !faqs.length">EMPTY FAQ LIST</div>
  <div
    class="faqs"
    [class.faqs]="!faqStyle || faqStyle === 'simple'"
    [class.bordered-faqs]="faqStyle === 'borderedList'"
    *ngIf="faqs.length"
  >
    <div class="faq" *ngFor="let faq of faqs" [appStoryblok]="faq._editable">
      <h3>{{ faq.question | replaceText : replacer }}</h3>
      <div class="standard-text" [innerHTML]="faq.answer | storyblokRichText | replaceText : replacer"></div>
    </div>
  </div>
</app-block-wrapper>
